<template>
    <div class="card" style="min-height: calc(100vh - 180px)">
        <div class="bg-blue-light p-1">
            <TitleButton
                btnTitle="List"
                :showBtn="true"
                :showAddNew="false"
                title="PI Order Edit"
                @onClickCloseButton="navigateToListPage"
            />
            <div class="row gy-1">
                <div class="col-md-3">
                  <div class="d-flex align-items-center justify-content-between filter-label">
                    <label for="colFormLabel" class="col-form-label">Customer Name: </label>
                    <span class="filter-search-icon cursor-pointer" @click="onOpenContactSearchModal">
                            <i class="fas fa-search"></i>
                        </span>
                  </div>
                    <AsyncSelect
                        placeholder="Select Party"
                        v-model="contactProfile"
                        :api-service="fetchContactProfiles"
                        :additional-query="additionalContactQuery"
                        :format-label="formatPatientLabel"
                    />
                </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
                  <label for="colFormLabel" class="col-form-label">Buyer Name: </label>
                <AsyncSelect placeholder="Select Buyer Name" v-model="buyerProfile"
                             :api-service="fetchContactProfiles" :additional-query="additionalBuyerOption"
                             :format-label="formatPatientLabel"/>
              </div>

              <div class="col-12 col-sm-6 col-md-4 col-lg-3">
              <label for="colFormLabel" class="col-form-label">Sales Person: </label>
                <AsyncSelect placeholder="Select Sales Person" v-model="salesProfile"
                             :api-service="fetchContactProfiles" :additional-query="additionalSalesOption"
                             :format-label="formatPatientLabel" />
              </div>

              <div class="col-md-3">
                <label class="form-label">Order Date</label>
                <input
                    class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                    tabindex="1"
                    type="date"
                    placeholder=""
                    v-model="formData.date"
                >
              </div>

              <div class="col-md-3">
                <label class="form-label">Country of Origin</label>
                <v-select :options="countryOptions" v-model="formData.country" label="name"
                          :reduce="option => option.name" placeholder="Select a Country"></v-select>
              </div>
              <div class="col-md-3">
                <label class="form-label">Loading Port</label>
                <input class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                       tabindex="1" type="text" placeholder="Please add loading port" v-model="formData.loading_port">
              </div>
              <div class="col-md-3">
                <label class="form-label">Delivery Port</label>
                <input class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                       tabindex="1" type="text" placeholder="Please add delivery port"
                       v-model="formData.delivery_port">
              </div>
              <div class="col-md-3">
                <label class="form-label">Quotation Ref & date</label>
                <input class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                       tabindex="1" type="text" placeholder="Please add quotation ref & date"
                       v-model="formData.order_number">
              </div>
              <div class="col-md-3">
                <label class="form-label">Currency</label>
                <v-select :options="currencyOptions" v-model="formData.currency" label="name"
                          :reduce="option => option.code" placeholder="Select a Currency"></v-select>
              </div>
            </div>
        </div>

        <div class="px-3">
          <ProductForm @handleProductAdd="handleProductAdd" ref="productForm" />
          <ProductsTable :itemDetails="formData.item_details" @removeBill="removeBill" :formRef="productForm" />
        </div>

      <div class="px-2">
        <div class="row justify-content-end">
          <div class="col-12 col-md-4">
            <div class="row">
              <div class="col-12">
                <div class="mb-1 row">
                  <div class="col-sm-4">
                    <label class="col-form-label" for="first-name">Total Amount</label>
                  </div>
                  <div class="col-sm-8">
                    <input v-model="total" readonly type="text" class="form-control text-right">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-12 px-2">
        <div class="mb-1">
          <label class="form-label" for="description">Terms & Condition</label>
          <vField as="textarea" name="description" type="number" class="form-control"
                  v-model="formData.description" />
        </div>
      </div>

        <div class="pb-5 px-2 mt-4">
            <div class="d-flex flex-wrap gap-1 gy-2">
                <button :disabled="saveButtonLoader || saveNewButtonLoader" @click="handleSubmit(true)" class="btn btn-primary">
                  Update
                </button>
                <button :disabled="productLoader" @click="navigateToListPage" class="btn btn-outline-secondary">Cancel</button>
            </div>
        </div>

         <Loader v-if="loader"/>
         <ContactDropdownFilter
             v-if="store.state.isModalOpenThree"
             @onSearchContact="onSearchContact"
             type="supplier"
             :companyRoles="companyRoles"
         />
    </div>
</template>

<script setup>
import { ref, inject, onMounted, computed, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import handlePurchase from '@/services/modules/purchase'
import handleBusinessesLocations from '@/services/modules/businessesLocations'
import handleContact from '@/services/modules/contact'
import Loader from '@/components/atom/LoaderComponent'
import TitleButton from '@/components/atom/TitleButton'
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import {useAsyncDropdownHelper} from "@/services/utils/asyncDropdownHelper";
import {useStore} from "vuex";
import ContactDropdownFilter from "@/components/atom/Contact/ContactDropdownFilter.vue";
import handleRole from "@/services/modules/role";
import handleInventory from '@/services/modules/inventory'
import ProductForm from "./ProductForm.vue";
import ProductsTable from "./ProductsTable.vue";

const router = useRouter()
const route = useRoute()
const store = useStore()

const showError =  inject('showError');
const showSuccess =  inject('showSuccess');

const {fetchProductList, ...rest} = handlePurchase()
const {fetchBusinessLocationsList} = handleBusinessesLocations()
const { formatPatientLabel } = useAsyncDropdownHelper();
const {fetchContactProfiles} = handleContact()
const { fetchCompanyDefaultRoles } = handleRole();
const { fetchCountryOfOrigins } = handleInventory()

const companyId = computed(() => {
    return route.params.companyId
})
let loader =ref(false)
let productLoader =ref(false)
let saveButtonLoader=ref(false)
let saveNewButtonLoader =ref(false)
let products = ref([])
let contacts = ref([])
let business = ref([])
let locations = ref([])
const companyRoles = ref([]);
let vatPayable = ref([])
const contactProfile = ref(null)
const buyerProfile = ref(null);
const salesProfile = ref(null);
const countries = ref([])
const productForm = ref(null);
const formData = ref({
  company_id: companyId,
  contact_profile_id: null,
  buyer_id: null,
  sales_person_id: null,
  account_head_id: null,
  business_id: null,
  location_id: null,
  currency: null,
  bill_number: '',
  status: 'active',
  date: '',
  has_item_detail: true,
  description: '',
  account_details: [],
  item_details: [],
  discount_amount: 0,
  loading_port: '',
  delivery_port: '',
  country_of_origin: null,
  sale_type: 'pi_order'
})
const additionalContactQuery = ref({
    with_mobile: 1,
    with_donors: 1,
    roles: 'customer,lead'
});

const additionalBuyerOption = ref({
  with_mobile: 1,
  with_donors: 1,
  dealer_id: '',
  roles: 'buyer'
});

const additionalSalesOption = ref({
  with_mobile: 1,
  with_donors: 1,
  dealer_id: '',
  roles: 'sales_representative'
});

function onOpenContactSearchModal() {
  store.state.isModalOpenThree = true;
}

function onSearchContact(contact) {
  contactProfile.value = contact
}

const countryOptions = computed(() => {
  return Object.values(countries.value).map(country => {
    return {
      code: country.name,
      name: country.name,
    };
  });
});

const currencyOptions = computed(() =>
    Object.values(countries.value).map(currency => ({
      code: currency.currency,
      name: currency.currency,
    }))
);

onMounted(async () => {
    loader.value=true
    const companyQuery = `?company_id=${companyId.value}`
    const productRes = fetchProductList(companyQuery)
    const payableRes = rest.fetchAccountReceivable(companyQuery)
    const fetchSingleSalesOrder = rest.fetchSalesOrderById(route.params.salesId, companyQuery)
    const getCountryOfOrigins = fetchCountryOfOrigins(companyQuery)

    Promise.all([
        productRes.then(res=> {
            if(res.data) products.value = res.data
        }),
        fetchCompanyDefaultRoles(companyQuery).then(res => {
          if (res.data) companyRoles.value = res.data
        }),
        payableRes.then(res=> {
            if(res.data.length) {
                formData.value.account_head_id = res.data[0].id
            }
        }),
        getCountryOfOrigins.then(res => {
          countries.value = res.data
        }),

        fetchSingleSalesOrder.then(res => {
          if(! res.data) {
            return
          }
          formData.value = res.data
          if(res.data.has_item_detail) {
            formData.value.item_details = res.data.general
            formData.value.has_item_detail = true
          }
          if(res.data.contact){
            contactProfile.value = res.data.contact
          }
          if(res.data.buyer){
            buyerProfile.value = res.data.buyer
          }
          if(res.data.sales_person){
            salesProfile.value = res.data.sales_person
          }
        })
    ])
    .then(() => {loader.value=false})
    .catch((err)=>{loader.value=false})
})

const handleProductAdd = (item, index) => {
  if (index !== null && Array.isArray(formData.value.item_details) && !!formData.value.item_details[index]) {
    formData.value.item_details[index] = item;
    return;
  }

  formData.value.item_details.push(item);
}
function removeBill(index) {
  formData.value.item_details.splice(index, 1)
}

const subTotal = computed(() => {
    let subTotal=0
    if (formData.value.has_item_detail) {
      formData.value.item_details.map(item => {
        subTotal += parseFloat((item.quantity * item.rate) - (item.discount_amount ?? 0))
      })
    }

    return subTotal
})

const totalVAT = computed(() => {
    let vat=0
    if(formData.value.has_item_detail) {
        formData.value.item_details.map(item => {
          if(item.vat_amount) {
            vat += parseFloat(item.vat_amount)
          }
        })
    }

    return vat.toFixed(2)
})

const total = computed(() => {
    return parseInt(subTotal.value) + parseInt(totalVAT.value)
})

function navigateToListPage() {
    const query = Object.assign({}, route.query)

    router.push({
        name: 'pi-order-list' ,
        params: route.params, 
        query: query
    })
}

function handleSubmit(redirect=false) {
    if(redirect) {
        saveButtonLoader.value = true
    } else {
        saveNewButtonLoader.value = true
    }
    if(!formData.value.date) formData.value.date = new Date().toISOString().split('T')[0]
    let copyFormData = Object.assign({}, formData.value)
    copyFormData.has_item_detail = formData.value.has_item_detail ? 1 : 0
    copyFormData.item_details = formData.value.item_details

    copyFormData.contact_profile_id = contactProfile.value ? contactProfile.value.id : null
    copyFormData.buyer_id = buyerProfile.value ? buyerProfile.value.id : null
    copyFormData.sales_person_id = salesProfile.value ? salesProfile.value.id : null

    rest.updateSalesOrder(route.params.salesId,  copyFormData)
    .then(res => {
        saveButtonLoader.value = false
        saveNewButtonLoader.value = false
        productLoader.value = false

        if(!res.status) {
          showError(res.message)
          return
        }

        showSuccess(res.message)
        if(redirect) navigateToListPage()
        resetForm()
    })
    .catch( () => {
        saveButtonLoader.value = false
        saveNewButtonLoader.value = false
    })
}

function resetForm() {
  formData.value.item_details = []
  formData.value.description = '';
  contactProfile.value = null;
}

</script>
